import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import PrintBonConsultation from '@/components/caisse/factures/print-bons/bon-consultation/bon-consultation-print'

export default {
    name: 'bon-consultation',
    components: {
        DateFilter, EnteteBonEtFacture,
        PrintBonConsultation
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,
            filename: '',
            selected_bon: {
                info_bon_consultation: {
                    date: "",
                    reference: "",
                    nom_patient: "",
                    sexe: "",
                    telephone: "",
                    assurance: null,
                    societe_souscripteur: null,
                    expire_date: "",
                    validite: ""
                },
                libelle: "",
                prix_clinique: "",
                montant_du: "",
                montant_restant: null,
                remise: "",
                etat_annulation: null,
                etat_paiement: "",
                qte: "",
                montant_paye: "",
                part_assureur: null,
                base_assurance: null,
                taux_couverture: null,
                date: "",
                consommables_bon: [
                    {
                        uid: "",
                        data_type: "",
                        prix_clinique: "",
                        montant_du: "",
                        montant_restant: null,
                        remise: null,
                        etat_annulation: null,
                        etat_paiement: "",
                        qte: "",
                        montant_paye: "",
                        part_assureur: null,
                        base_assurance: null,
                        taux_couverture: null,
                        libelle: ""
                    },
                ]
            },
            total_du: 0,
            total_a_payer: 0,
            total_taxe_specifique: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.getListeBonConsultation(data)
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        bons_consultation_factures() {
            return this.$store.getters['bons_consultation_factures'];
        },

        bons_length() {
            return this.bons_consultation_factures.length;
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },

    methods: {
        getListeBonConsultation(data) {
            this.is_load_error = false
            this.is_loading = true
            console.log(data);
            this.$store.dispatch("getBonConsultationFacture", data).then(() => {
                if (this.bons_consultation_factures.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeBonConsultation(data)
        },

        viewDetail(bon) {
            const tmpstamp = this.current_date.getTime()
            this.filename = 'Bon de consultation_'+bon.info_bon_consultation.nom_patient+'_'+tmpstamp

            this.selected_bon = bon

            this.total_a_payer = 0
            this.total_du = 0

            this.total_du = bon.montant_du
            this.total_a_payer += (bon.prix_clinique > bon.base_assurance)?bon.prix_clinique:bon.base_assurance
            this.total_taxe_specifique += bon.taxe_specifique

            bon.consommables_bon.forEach(consommable => {
                if (consommable.data_type == 'apport_social') {
                    this.total_du -= consommable.montant_du
                } else {
                    this.total_du += consommable.montant_du
                    this.total_a_payer += consommable.prix_clinique
                }
                
                this.total_taxe_specifique += consommable.taxe_specifique
            });

            setTimeout(() => {
                $('.print-bon-consultation').modal('show')
            }, 500); 
        }
    }
}